import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { trpc } from "@/hooks/trpc";
import { RoomDisplay } from "@/features/room-display/RoomDisplay";

const searchSchema = z.object({
  device: z.string().optional(),
});

export const Route = createFileRoute("/kiosk")({
  validateSearch: searchSchema,
  component: KioskPage,
});

function KioskPage() {
  const { device } = Route.useSearch();

  const { data: room } = trpc.rooms.getByDeviceId.useQuery(
    { deviceId: device ?? "" },
    { enabled: !!device, refetchInterval: 5_000 },
  );

  if (!device || !room) {
    return <UnassignedScreen deviceId={device} />;
  }

  return <RoomDisplay roomId={room.id} />;
}

function UnassignedScreen({ deviceId }: { deviceId?: string }) {
  return (
    <div className="h-screen w-screen bg-neutral-900 flex flex-col items-center justify-center gap-4">
      <p className="text-white/40 text-sm uppercase tracking-widest">Not configured</p>
      {deviceId && (
        <>
          <p className="text-white/20 text-xs">Device ID</p>
          <p className="text-white text-3xl font-mono font-bold tracking-widest">
            {deviceId}
          </p>
          <p className="text-white/20 text-xs mt-2">
            Enter this ID in the admin panel to assign a room
          </p>
        </>
      )}
    </div>
  );
}
